import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ElectronicDocumentTemplate from '../pages/DocumentTemplate/ElectronicDocumentTemplate';
import ProtectedRouteV2 from './ProtectedRouteV2';

const dteTemplateRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/dte-templates"
      element={
        <>
          <PageTitle title="Plantillas de Documentos Electrónicos | POS System" />
          <ElectronicDocumentTemplate />
        </>
      }
    />
  </Route>
);

export default dteTemplateRoutes;
